import PropertyLowRatesCalendar from '../../../../components/containers/PropertyLowRatesCalendarContainer';
import preloadCustomProps from '../../../utils/preloads/preloadPropertyLowRatesCalendarProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'property-low-rates-calendar',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PropertyLowRatesCalendar
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
